import { render, staticRenderFns } from "./MyDashboards.vue?vue&type=template&id=68480446&scoped=true&"
import script from "./MyDashboards.vue?vue&type=script&lang=js&"
export * from "./MyDashboards.vue?vue&type=script&lang=js&"
import style0 from "./MyDashboards.vue?vue&type=style&index=0&id=68480446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68480446",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/acarmichael/Desktop/DEV/BOSS40-FrontEnd/boss-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
